// Documento: Como conectar WhatsApp Business app
// Categoría: WhatsApp
// Última actualización: 2024-12-28

const document = {
  "id": "conectar-whatsapp-business-app",
  "title": "Como conectar WhatsApp Business app",
  "category": "WhatsApp",
  "description": "Aprende a conectar tu cuenta de WhatsApp Business app existente a Runamatic, manteniendo la convivencia entre ambas plataformas para una ventaja estratégica.",
  "explanations": [
    {
      "title": "Ventaja de la convivencia",
      "content": "Runamatic permite la convivencia de WhatsApp Business app (la app para teléfonos) con nuestro sistema, esto es una ventaja estratégica para muchos de nuestros clientes. En este documento veremos como poder hacerlo."
    },
    {
      "title": "Requisitos previos",
      "content": "Asegúrese de estar logueado con un usuario de Meta que tenga acceso al portfolio comercial donde desea vincular esta cuenta de WhatsApp o donde esta cuenta ya esté vinculada."
    },
    {
      "title": "Sobre los métodos de pago",
      "content": "Meta permitirá trabajar más tranquilamente a las cuentas que tengan métodos de pago asociadas. Los pagos solo se aplicarán si se hace uso de la mensajería masiva o se envían plantillas de WhatsApp."
    }
  ],
  "videoTutorial": {
    "title": "Video Tutorial",
    "url": "https://youtu.be/58uE6atrQpE",
    "description": "Mira este video tutorial paso a paso para conectar tu WhatsApp Business app a Runamatic"
  },
  "steps": [
    {
      "title": "Iniciar la conexión",
      "content": "Para comenzar vaya a Ajustes > Canales > WhatsApp > Conectar."
    },
    {
      "title": "Continuar sin seleccionar opciones",
      "content": "Seleccione \"Continuar\" sin seleccionar ninguna opción."
    },
    {
      "title": "Verificar usuario de Meta",
      "content": "Asegúrese de estar logueado con un usuario de Meta que tenga acceso al portfolio comercial donde desea vincular esta cuenta de WhatsApp o donde esta cuenta ya esté vinculada. Continue con ese usuario."
    },
    {
      "title": "Empezar el proceso",
      "content": "Seleccione \"Empezar\"."
    },
    {
      "title": "Configurar información empresarial",
      "content": "Seleccione su portfolio comercial. Complete el nombre de la empresa y sitio web de la empresa (si no tiene sitio web puede ser su página de Instagram). Tenga en cuenta que esta información será visible a los clientes, luego haga click en \"Siguiente\"."
    },
    {
      "title": "Conectar app existente",
      "content": "Seleccione \"Conecta tu app de WhatsApp Business existente\" y haga click en \"Siguiente\"."
    },
    {
      "title": "Ingresar número de teléfono",
      "content": "Elija su código de país, ingrese su número de teléfono de la cuenta de WhatsApp a conectar y haga click en \"Siguiente\"."
    },
    {
      "title": "Continuar proceso",
      "content": "Haga click en \"Siguiente\"."
    },
    {
      "title": "Escanear código QR",
      "content": "Continue hasta que se le muestre un código QR. En ese momento se le enviará un mensaje de WhatsApp a su teléfono con un link para escanear el código. Una vez escaneado el código, la cuenta de WhatsApp será integrada a Runamatic."
    },
    {
      "title": "Agregar método de pago (recomendado)",
      "content": "Luego de integrada la cuenta de WhatsApp le aparecerá la opción de agregar método de pago a esta cuenta. Recomendamos agregar un método de pago ya que Meta permitirá trabajar más tranquilamente a las cuentas que tengan métodos de pago asociadas."
    }
  ],
  "tags": [
    "whatsapp",
    "business",
    "app",
    "conexión",
    "configuración",
    "meta",
    "portfolio"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
